export const ADD_SELECTION_GIFT_MUTATION = `
mutation CartMutation($gift: AddGiftSelectionPayloadDtoInputType!){
  addGiftSelection(gift: $gift) {
      data {
        itemId
      }
      messages
  }
}`;
